import { FC } from 'react';

import DownloadTableModalHeader from './components/DownloadTableModalHeader';
import DownloadTableModalBody from './components/DownloadTableModalBody';
import DownloadTableModalFooter from './components/DownloadTableModalFooter';

import '../Modals.scss';
import { useDownloadTableModal } from './context/DownloadTableModalContext';
import CustomLoading from '../../CustomLoading';

const DownloadTableModal: FC = () => {
  const { data } = useDownloadTableModal();

  return (
    <>
      <DownloadTableModalHeader />
      <DownloadTableModalBody />
      <DownloadTableModalFooter />

      {data.isLoading && <CustomLoading />}
    </>
  );
};

export default DownloadTableModal;
